/**
 * 模組頁面代碼: 1210-UI
 * 模組說明: 案件詳細資料頁面
 * @module CaseDetailContainer
 */

// ----- import from local libraries -----
import {React, PropTypes, connect, BaseComponent, AccessModeEnums} from '../../components/BaseComponent';

// ----- import from local components -----
import Header from '../../features/main-frame/components/Header';
import Footer from '../../features/main-frame/components/Footer';
import Sidebar from '../../features/main-frame/components/Sidebar';
import {useSelector} from 'react-redux';
import SatisfactionSurveyDetailPage from './components/SatisfactionSurveyDetailPage';

// ----- constants and enums -----

const SatisfactionSurveyDetailContainer = (props) => {
  const userPermissions =
    useSelector((state) => JSON.parse(state.access.userPermissions));
  return (
    <>
      <div className="m__wrap">
        <Header />
        <div className="m__contents">
          <Sidebar />
          <SatisfactionSurveyDetailPage {...props} userPermissions={userPermissions} />
        </div>
        <Footer />
      </div>
    </>
  );
};

export default SatisfactionSurveyDetailContainer;
